export const isTouchDevice = (): boolean => {
  var DocumentTouch: any; //object inside window not supported by typescript
  const touchWindow = <any>window; //make the window object any to support ".DocumentTouch"

  const prefixes = " -webkit- -moz- -o- -ms- ".split(" ");

  const mq = function (query) {
    return window.matchMedia(query).matches;
  };

  if ("ontouchstart" in window || (touchWindow.DocumentTouch && document instanceof DocumentTouch)) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
  return mq(query);
};
